import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { NzModalService } from 'ng-zorro-antd';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    // Observables
    showModal$ = new Subject();
    hideModal$ = new Subject();

    constructor(
        private router: Router,
        private translate: TranslateService,
        private modal: NzModalService
    ) {
        this.showModal$
            .withLatestFrom(this.hideModal$, (option, closed) => ({ option: option, closed: closed }))
            .debounceTime(500)
            .subscribe(x => {
                if (x.closed) {
                    this.hideModal$.next(false);
                    const modals = this.modal.error(x.option);
                    setTimeout(() => modals.destroy('onCancel'), 3000);
                    console.log(x.option['content']);
                } else {
                    console.log(x.option['content']);
                }
            });

        this.hideModal$.next(true);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token: string = sessionStorage.getItem('token') || '';
        const headers = req.headers
            .set('Authorization', token);

        const authReq = req.clone({
            headers: headers
        });
        return next.handle(authReq).do(event => {
            if (event instanceof HttpResponse) {
                const response = event.body;
                try {
                    if (!response || !response.head) return;
                    if (response.head.errorCode === '0001') {
                        // 没有权限跳转到登录
                        this.showModal$.next({
                            title: this.translate.instant('common.authentication-error'),
                            content: response['head']['errorMsg'],  // '您的账号没有访问当前页面或数据的权限,请重新登录',
                            onOk: resolve => {
                                this.hideModal$.next(true);
                                sessionStorage.removeItem('token');   // 此处清除session再跳到登录
                                this.router.navigate(['login']);
                            },
                            onCancel: resolve => {
                                this.hideModal$.next(true);
                                sessionStorage.removeItem('token');   // 此处清除session再跳到登录
                                this.router.navigate(['login']);
                            }
                        });
                    } else if (response.head.errorCode === '0000' || response.head.errorCode === '-1') {
                        // 服务端异常报错
                        // alert(response['head']['errorMsg']);
                        this.showModal$.next({
                            title: this.translate.instant('common.error'),
                            content: response['head']['errorMsg'] || this.translate.instant('common.unknown-error'),
                            onOk: resolve => {
                                this.hideModal$.next(true);
                            },
                            onCancel: resolve => {
                                this.hideModal$.next(true);
                            }
                        });
                    }
                } catch (error) {
                    console.error(this.translate.instant('common.request-error'));
                }
            }
        }).catch(err => {
            if (err.status && err.status !== 200) {
                console.log(err);
                this.showModal$.next({
                    title: this.translate.instant('common.error'),
                    content: this.translate.instant('common.unknown-error') + err.status,
                    onOk: resolve => { this.hideModal$.next(true); },
                    onCancel: resolve => { this.hideModal$.next(true); }
                });
            }
            return Observable.throw(err);
        });
    }
}

export const HttpAuthProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
};



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/implements/auth.interceptor.ts